import AdvocateRajaniDetails from '../../components/about/advocates-details/rajani';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateRajaniDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | Ms. B. Rajani Rathod'>
      <NavigationMenu active='about' />
      <PageHeader
        title='Ms. B. Rajani Rathod'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateRajaniDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateRajaniDetailsPage;

